var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 58C23.2643 58 17.6575 56.2992 12.8885 53.1126C8.11945 49.9261 4.40245 45.3969 2.20751 40.0978C0.0125652 34.7988 -0.561731 28.9678 0.55724 23.3424C1.67621 17.7169 4.43819 12.5496 8.49391 8.49391C12.5496 4.43819 17.7169 1.67621 23.3424 0.55724C28.9678 -0.561731 34.7988 0.0125652 40.0978 2.20751C45.3969 4.40245 49.9261 8.11945 53.1126 12.8885C56.2992 17.6575 58 23.2643 58 29C58 36.6913 54.9446 44.0675 49.5061 49.5061C44.0675 54.9446 36.6913 58 29 58ZM29 4.14287C24.0837 4.14287 19.2779 5.60071 15.1901 8.33205C11.1024 11.0634 7.91638 14.9455 6.03501 19.4876C4.15363 24.0296 3.66137 29.0276 4.62049 33.8494C5.57961 38.6712 7.94702 43.1003 11.4234 46.5767C14.8997 50.053 19.3288 52.4204 24.1506 53.3795C28.9724 54.3386 33.9704 53.8464 38.5124 51.965C43.0545 50.0836 46.9366 46.8976 49.668 42.8099C52.3993 38.7222 53.8571 33.9163 53.8571 29C53.8571 22.4075 51.2383 16.085 46.5767 11.4234C41.915 6.76174 35.5925 4.14287 29 4.14287ZM26.2243 38.8393L44.8671 22.2679L42.1329 19.1607L24.8572 34.4479L15.9707 25.4579L13.0293 28.3993L23.3864 38.7564C23.58 38.9484 23.8095 39.1003 24.0619 39.2034C24.3143 39.3065 24.5845 39.3587 24.8572 39.3571C25.3607 39.3564 25.8467 39.1723 26.2243 38.8393Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.e7033f5334dcdfb66745adde599df09c.svg";
export { ForwardRef as ReactComponent };